export const PROPS_OPTIONS_TITLE_INDEX = {
  titleIndex: {
    type: Number,
    default: 0
  },
  examIndex: {
    type: Number,
    default: 0
  }
}

export const PROPS_OPTIONS_ANSWER_ROW = {
  isShowBg: {
    type: Boolean,
    default: false
  },
  isShowCorrect: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
}

export const PROPS_OPTIONS = {
  ...PROPS_OPTIONS_ANSWER_ROW,
  themeName: {
    type: String,
    default: () => 'default'
  },
  showSingleRowScaleTitle: {
    type: Boolean,
    default: false
  },
  item: {
    type: Object,
    default: () => ({})
  },
  beforeChange: {
    type: Function,
    default: () => true
  }
}
